import { Global, css } from "@emotion/react";
import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";

//MUI
import styled from "@emotion/styled";

//components
import ResponsiveAppBar from "../components/AppBar";
import ErrorBoundary from "../components/ErrorBoundary";
import ModalMain from "../components/Modals";

// Global Styles
const GlobalStyles = () => (
  <Global
    styles={css`
      iframe#webpack-dev-server-client-overlay {
        display: none !important;
      }
    `}
  />
);

const Container = styled("div")(({ theme, noAppBar }) => ({
  width: "100vw",
  height: "100vh",
  background: "#FFFFFF",
  display: "flex",
  flexDirection: "column",
  "& .main": {
    width: "100vw",
    flex: "1 1 auto",
    minHeight: 0,
    overflow: "auto",
  },
}));

const AppLayout = ({ setActivateLog }) => {
  const location = useLocation();

  const shouldHideAppBar = location.pathname.startsWith("/app/explore_ai");

  return (
    <>
      <GlobalStyles />
      <Container noAppBar={shouldHideAppBar}>
        {!shouldHideAppBar && <ResponsiveAppBar />}
        <div className="main">
          <Suspense fallback={<p>Loading...</p>}>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Suspense>
        </div>
        <ModalMain />
      </Container>
    </>
  );
};

export default AppLayout;
